export function convertDate(date) {
  const stringDate = String(date),
    year = stringDate.slice(0, 4),
    month = stringDate.slice(4, 6),
    day = stringDate.slice(6, 8);

  const dateEnd = day + '/' + month + '/' + year;

  return dateEnd;
}
